import React from 'react';
import UserFb from './UserFb';

export default class HeaderElement extends React.Component {

	render() {

		return (
			<div className="header">
				<div className="container">
					<a href="http://www.landrover.es/index.html" target="_blank" className="logo-landrover"><img src="img/logo-landrover.png" alt="Land Rover"/></a>
					<div  className="logo-app">								
						<img src="img/aventura-increible.png" alt="Aventura Increible" className="img-responsive" />
					</div>
					
					<UserFb />
					
				</div>
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/HeaderElement.js